export const LOGIN_ROUTE = '/auth';
export const LOGOUT_ROUTE = '/logout';
export const FORBIDDEN_ROUTE = '/forbidden';

export const APP_VERSION = '1.1.0';

export const INVALID_USER_MESSAGE = 'Necessária a reautenticação.';

export const ENABLE_EDIT_REQUEST_FIGURANT = true;

export const ENABLE_AUTO_SELECT_FIGURANT_AND_INSPECTOR = false;
